/**
 * Enum representing different environments where the chatbot can be used
 */
export enum ChatbotEnv {
  GLOBAL = "GLOBAL",
  FORECASTING_CALENDAR = "FORECASTING_CALENDAR",
  PLANNER_FILE_HANDLING = "PLANNER_FILE_HANDLING",
  FORECASTING_KANBAN = "FORECASTING_KANBAN"
}

/**
 * Format the ChatbotEnv enum value for display
 * @param env The ChatbotEnv value to format
 * @returns A formatted string representation of the ChatbotEnv value
 */
export function formatChatbotEnv(env: ChatbotEnv): string {
  switch (env) {
    case ChatbotEnv.GLOBAL:
      return "Global";
    case ChatbotEnv.FORECASTING_CALENDAR:
      return "Forecasting Calendar";
    case ChatbotEnv.PLANNER_FILE_HANDLING:
      return "Planner File Handling";
    case ChatbotEnv.FORECASTING_KANBAN:
      return "Forecasting Kanban";
    default:
      return "Unknown";
  }
}